import React from 'react'
import styled from 'styled-components'
import { useLocalLabels, Link } from '@sentecacommerce-theme/lib'
import { ShopByAgeItem, ShopByAgeLabels } from '..'
import { LazyImage } from '../../Common'

type Props = {
  data: ShopByAgeItem
}

const Age = ({ data }: Props) => {
  // TODO: FIX aria-label and alt when values are here
  const labels = useLocalLabels<ShopByAgeLabels>()
  return (
    <Link href={data.url} passHref>
      <SlideContainer aria-label={labels?.ariaAndAlt}>
        <CircleContainer>
          <LazyImage
            width={140}
            height={140}
            src={data.image}
            alt={labels?.ariaAndAlt} /* TODO: fix */
          />
        </CircleContainer>
      </SlideContainer>
    </Link>
  )
}

const SlideContainer = styled.a.attrs({
  className: 'd-flex align-items-center justify-content-center',
})`
  position: relative;
  border-radius: 50%;
`

const CircleContainer = styled.figure`
  position: relative;
  width: 11.7rem;
  height: 11.7rem;
  transform: translateY(0);

  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    transform: translateY(-0.5rem);
  }

  & * {
    border-radius: 50%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    width: 16rem;
    height: 16rem;
  }
`

export { Age }
